// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import HomeFilledSvg from "@fishx/icons-svg/es/asn/HomeFilled";
import FishxIcon from '../components/FishxIcon';

var HomeFilled = function HomeFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: HomeFilledSvg
  }));
};

HomeFilled.displayName = 'HomeFilled';
export default React.forwardRef(HomeFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/HomeFilled.js
// module id = 2936
// module chunks = 0